<nav class="navbar navbar-expand-lg navbar-light justify-content-between"
     [ngClass]="{'scrolled': scrolled, 'home' : this.router.url === '/home'}">
  <div class="d-flex flex-grow-1 logo-holder">
    <a class="navbar-brand ml-auto" [routerLink]="['/home']">
      <img src="assets/img/logo.webp" alt="Logo van Steddie" width="160" height="80">
    </a>
    <div class="w-100 text-right hamburger-container">
      <button class="navbar-toggler" type="button" aria-expanded="false" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar" aria-label="(De)Activeer navigatie">
        <i class="bi bi-list"></i>
      </button>
    </div>
  </div>
  <div class="mobile-grayout" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar"></div>
  <div class="collapse navbar-collapse flex-grow-1 text-right" id="steddie-navbar">
    <div class="mobile-close" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
      <i class="bi bi-x-lg"></i></div>
    <ul class="navbar-nav ms-auto flex-nowrap align-items-center">
      <li class="nav-item px-2">
        <a [routerLink]="['/home']" routerLinkActive="active" class="nav-link m-2 menu-item nav-active" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
          Home
        </a>
      </li>
      <li class="nav-item px-2">
        <a [routerLink]="['/activiteiten']" routerLinkActive="active" class="nav-link m-2 menu-item nav-active" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
          Activiteiten
        </a>
      </li>
      <li class="nav-item px-2">
        <a [routerLink]="['/organisaties']" routerLinkActive="active" class="nav-link m-2 menu-item nav-active" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
          Voor organisaties
        </a>
      </li>
      <li class="nav-item px-2">
        <a [routerLink]="['/contact']" routerLinkActive="active" class="nav-link m-2 menu-item nav-active" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
          Over ons
        </a>
      </li>
      <div class="nav-item px-2 dropdown" *ngIf="(authService.loggedIn$ | async) && !hide_large">
        <a class="nav-link m-2 menu-item dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Mijn account
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" [routerLink]="['/profiel']" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
              Profiel weergeven
            </a>
          </li>
          <li *ngIf="authService.linkedToOrganization">
            <a class="dropdown-item" [routerLink]="['/mijn-organisatie']" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
              Mijn organisatie
            </a>
          </li>
          <hr>
          <li><a class="dropdown-item" (click)="signOut()">Afmelden</a></li>
        </ul>
      </div>
      <div *ngIf="(authService.loggedIn$ | async) && hide_large" class="w-100">
        <li class="nav-item px-2">
          <a [routerLink]="['/profiel']" routerLinkActive="active" class="nav-link m-2 menu-item nav-active" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
            Profiel weergeven
          </a>
        </li>
        <li class="nav-item px-2" *ngIf="authService.linkedToOrganization">
          <a [routerLink]="['/mijn-organisatie']" routerLinkActive="active" class="nav-link m-2 menu-item nav-active" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
            Mijn organisatie
          </a>
        </li>
      </div>
      <li class="nav-item px-3">
        <button type="button" *ngIf="!(authService.loggedIn$ | async)" [routerLink]="['/account/inloggen']" class="btn btn-login">
          Inloggen
        </button>
        <button type="button" *ngIf="(authService.loggedIn$ | async) && authService.linkedToOrganization" [routerLink]="['/activiteit/aanmaken']" class="btn btn-login" data-bs-toggle="collapse" data-bs-target="#steddie-navbar" aria-controls="steddie-navbar">
          Activiteit plaatsen
        </button>
      </li>
    </ul>
  </div>
</nav>
